import { type RefObject, useEffect } from 'react'

/** CSS-collapsed mobile headers must not retain keyboard-accessible controls. */
export const useMobileInert = (
  ref: RefObject<HTMLElement>,
  hidden: boolean,
): void => {
  useEffect(() => {
    const element = ref.current
    if (!element) return
    const desktop = window.matchMedia?.('(min-width: 1280px)')
    const update = () => {
      if (hidden && !(desktop?.matches ?? window.innerWidth >= 1280))
        element.setAttribute('inert', '')
      else element.removeAttribute('inert')
    }
    update()
    desktop?.addEventListener('change', update)
    window.addEventListener('resize', update)
    return () => {
      element.removeAttribute('inert')
      desktop?.removeEventListener('change', update)
      window.removeEventListener('resize', update)
    }
  }, [ref, hidden])
}
